module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_7005.ab7d02c8.png";